import { post } from 'axios';

// limit 单位 M
const upload = async (file, limit = 1) => {
  if (!(file instanceof File)) {
    return {
      data: {
        error_code: 1,
        message: '没有选中文件!'
      }
    }
  }
  const size = byteToM(file.size);
  if (size > limit) {

    return {
      data: {
        error_code: 1,
        message: `文件大小应该在 ${limit}M 以内!`,
      }
    }
  }
  try {
    const form = new FormData();
    form.append('file', file);

    const res = await post(
      '/file/upload',
      form,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
    
    return res;
  } catch (err) {
    throw(err);
  }
}

const byteToM = (size) => {
  return size / 1024 / 1024;
}

export default upload;
